import { FC } from 'react';
import { TooltipRenderProps } from 'react-joyride';

interface FtuxTooltipProps extends TooltipRenderProps {
	currentStepIndex: number;
	totalSteps: number;
	paginatedStepIndex: number | null;
	paginatedStepTotal: number | null;
	onNext: () => void;
	onBack: () => void;
}

const FtuxTooltip: FC<FtuxTooltipProps> = ({
	step,
	tooltipProps,
	currentStepIndex,
	totalSteps,
	paginatedStepIndex,
	paginatedStepTotal,
	onNext,
	onBack
}) => {
	const isFirstStep = currentStepIndex === 0;
	const isLastStep = currentStepIndex === totalSteps - 1;
	const buttonLabel = step.data?.buttonLabel || (isLastStep ? 'Done' : 'Next');
	const displayCurrentStep = paginatedStepIndex ?? currentStepIndex + 1;
	const displayTotalSteps = paginatedStepTotal ?? totalSteps;
	const placement = step.placement || 'bottom';

	return (
		<div
			{...tooltipProps}
			className="ftux-tooltip"
			data-placement={placement}
			style={{
				border: 'none',
				borderWidth: 0
			}}
		>
			{/* Tooltip Content */}
			{step.content && (
				<div className="ftux-tooltip-content">
					{step.title && <h6 className="ftux-tooltip-title">{step.title}</h6>}
					<div dangerouslySetInnerHTML={{ __html: step.content.toString() }} />
				</div>
			)}

			{/* Pagination Controls */}
			<div className="ftux-tooltip-pagination">
				<div className="ftux-pagination-counter">
					<span className="current">{displayCurrentStep}</span>
					<span className="separator">/</span>
					<span className="total">{displayTotalSteps}</span>
				</div>
				<div className="ftux-pagination-buttons">
					{!isFirstStep && (
						<button type="button" onClick={onBack} className="btn btn-outline btn-sm">
							Back
						</button>
					)}
					<button type="button" onClick={onNext} className="btn btn-primary btn-sm">
						{buttonLabel}
					</button>
				</div>
			</div>
		</div>
	);
};

export default FtuxTooltip;
